/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Steps_H2Inputs */

const es_cap_steps_h2 = /** @type {(inputs: Cap_Steps_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De tu título a la bañera, en cuatro pasos.`)
};

const gl_cap_steps_h2 = /** @type {(inputs: Cap_Steps_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do teu título á banera, en catro pasos.`)
};

const en_cap_steps_h2 = /** @type {(inputs: Cap_Steps_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From your licence to the cockpit in four steps.`)
};

/**
* | output |
* | --- |
* | "From your licence to the cockpit in four steps." |
*
* @param {Cap_Steps_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_steps_h2 = /** @type {((inputs?: Cap_Steps_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Steps_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_steps_h2(inputs)
	if (locale === "en") return en_cap_steps_h2(inputs)
	return es_cap_steps_h2(inputs)
});